import { baseURL } from '../httpService/API';
import { hMacAjax } from 'grt-tool-lib-front';
import ServiceAPI from '@/httpService/serviceApi';
export const checkToken = () => {
    return hMacAjax.get(baseURL + '/grt-user-service/user/v1/token/check', {});
};

export const getWxConfig = async (data) => {
    return hMacAjax.get(baseURL + '/grt-user-service/user/v1/wx/sdk/getEncryptJsapiTicket', data);
};
export const getTenantList = () => {
    return hMacAjax.get(baseURL + '/grt-user-service/user/v1/tenant/list');
};

//获取租户门户列表
export const getTenantPortals = (params) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/decoration/portal', params);
};
//验证码登录
export const smsLogin = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v1/login/sms', data);
};

//多因子登录
export const codeVerifyLogin = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v2/login/sms', data);
};

//账号密码登录
export const accountLogin = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v2/login/account', data);
};

//发送验证码
export const getSms = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v1/sms_voice', data);
};

//忘记密码第一步
export const verifyFirst = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v1/forget/pwd/verify', data);
};

//忘记密码第二步
export const verifySecond = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v2/forget/pwd', data);
};

//用户信息
export const getUserInfo = () => {
    return hMacAjax.get(baseURL + '/grt-user-service/user/v1/');
};

//退出登录
export const outLogin = () => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v1/logout');
};

//
export const tenantSort = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-service/user/v1/tenant/sort', data);
};

// 全部区域
export const allAreaUrl = baseURL + '/grt-user-center-service/open/geo/v1/all';

// 获取临时密钥
export const getAESKey = () => {
    return hMacAjax.get(ServiceAPI.userAPI + '/open/user/v1/temp-aes-key/generate');
};
